module.exports = __webpack_public_path__ + "img/FI_TA.619d51e1.png";